<template>
  <div :v-if="listExist(name)">
    <div v-if="title" class="title-container">
      <prismic-rich-text
        :field="title"
        class="vectors-grid-title vx-custom-title"
      ></prismic-rich-text>
      <div v-if="buttonText && buttonPath" class="mx-2">
        <Button
          shape="outline"
          size="small"
          font-size="13"
          color="white"
          text="gray"
          hover="exp"
          :blank="buttonBlank"
          :to="buttonPath"
        >
          {{ buttonText }}
        </Button>
      </div>
    </div>
    <Grid :items="getVectorsList(name)" :hide-uncompleted-rows="true" @item-click="vectorClick">
      <template #default="slotProps">
        <NormalVectorOverlay :data="slotProps.data" />
      </template>
    </Grid>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Button from 'UI/Button';
import Grid from '@/components/Common/Grid';
import NormalVectorOverlay from '@/components/Vectors/NormalVectorOverlay';

export default {
  components: {
    Button,
    Grid,
    NormalVectorOverlay
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      buttonBlank: '',
      buttonPath: '',
      buttonText: '',
      ids: [],
      name: '',
      title: ''
    };
  },

  async fetch() {
    const inputName = this.slice.primary.grid_name[0]?.text;
    const { primary } = this.slice;

    this.title = primary?.title1[0]?.text ? primary.title1 : '';
    this.buttonText = primary.button_text && primary.button_text[0]?.text;
    this.buttonPath = primary.button_path && primary.button_path[0]?.text;
    this.buttonBlank = primary.button_blank;
    this.name = inputName
      ? inputName.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
      : '';

    this.slice.items.forEach((id) => {
      if (id.vector_id) this.ids.push(id.vector_id);
    });

    if (this.name && this.ids) {
      await this.$store.dispatch('vectors/LOAD_VECTOR_LISTING', {
        name: this.name,
        ids: this.ids
      });
    }
  },
  computed: {
    ...mapGetters('vectors', ['listExist', 'getVectorsList'])
  },
  methods: {
    async vectorClick({ item, shownListing }, e) {
      e.preventDefault();
      this.$bvModal.show('preview-vector-modal');
      await this.$store.dispatch('vectors/OPEN_PREVIEW', { id: item.id, list: shownListing });
    }
  }
};
</script>

<style lang="scss" scoped>
.vectors-grid-title {
  font-weight: 500;
  margin-top: 5px;
}
.title-container {
  display: flex;
  align-items: center;
  margin: 0 0 10px 5px;
}
.vx-custom-background .vx-custom-title {
  color: white;
}
</style>

<style lang="scss">
.vectors-grid-title {
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 1.25em;
  }
}
</style>
